(function () {
  'use strict';

  if (window.FellinoraLibraryTopicsLoaded) {
    return;
  }

  window.FellinoraLibraryTopicsLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initReveal(section) {
    var items = section.querySelectorAll('[data-fltd-reveal]');

    items.forEach(function (item, index) {
      item.style.setProperty('--fltd-delay', Math.min(index * 140, 280) + 'ms');
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('fltd-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('fltd-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -12% 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initStage(section) {
    var stage = section.querySelector('[data-fltd-stage]');

    if (!stage || !canHover.matches) {
      return;
    }

    function openStage() {
      stage.classList.add('is-open');
    }

    function closeStage() {
      stage.classList.remove('is-open');
    }

    stage.addEventListener('pointerenter', openStage);
    stage.addEventListener('pointerleave', closeStage);
    stage.addEventListener('focusin', openStage);
    stage.addEventListener('focusout', function (event) {
      if (!stage.contains(event.relatedTarget)) {
        closeStage();
      }
    });
  }

  function initSection(section) {
    initReveal(section);
    initStage(section);
  }

  function init() {
    document.querySelectorAll('[data-fltd-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fltd-section]');

    if (section) {
      initSection(section);
    }
  });
})();
